export enum FiltersActions {
  UPDATE_AGGREGATIONS = '[FiltersActions] UPDATE_AGGREGATIONS',
  UPDATE_AGGREGATIONS_SUCCESS = '[FiltersActions] UPDATE_AGGREGATIONS_SUCCESS',
  UPDATE_AGGREGATIONS_ERROR = '[FiltersActions] UPDATE_AGGREGATIONS_ERROR',
  TOGGLE_SHOW = '[FiltersActions] TOGGLE_SHOW',
  TOGGLE_ACTIVE = '[FiltersActions] TOGGLE_ACTIVE',
  SET_DATE_RANGE_FROM = '[FiltersActions] SET_DATE_RANGE_FROM',
  SET_DATE_RANGE_TO = '[FiltersActions] SET_DATE_RANGE_TO',
  SET_ACTIVE_FILTERS = '[FiltersActions] SET_ACTIVE_FILTERS',
  TOGGLE_EXPANDED = '[FiltersActions] TOGGLE_EXPANDED',
  CLEAR = '[FiltersActions] CLEAR',
}
